import { render } from "./cTALink.vue?vue&type=template&id=2f9692db"
import script from "./cTALink.vue?vue&type=script&lang=js"
export * from "./cTALink.vue?vue&type=script&lang=js"

import "./cTALink.vue?vue&type=style&index=0&id=2f9692db&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__